<cdk-accordion
    class="relative"
    [multi]="true">
    <ng-content accordionItem></ng-content>
</cdk-accordion>
